import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [
    "segmentBuilder",
    "wheelWallpaperReducer",
    "gallery",
    "codeblockStyles",
    "wheelSettings",
    "galleryPopup",
    "nonAuthenticatedModal",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
